module.exports = __webpack_public_path__ + "static/media/success-capture.60fab123.png";